import { motion } from "framer-motion";
import { FaReceipt } from "react-icons/fa";

export default function CartInvoice({
  orderDetails,
  restaurantName,
  onClose,
  onDownload,
}) {
  if (!orderDetails) return null;

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50"
      onClick={onClose}
    >
      <motion.div
        initial={{ scale: 0.9, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        exit={{ scale: 0.9, opacity: 0 }}
        className="bg-white rounded-2xl shadow-2xl max-w-md w-full max-h-[90vh] overflow-y-auto invoice-print"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="p-6">
          <div className="flex items-center justify-between mb-4 no-print">
            <h3 className="text-xl font-bold text-gray-800">Invoice</h3>
            <button
              onClick={onClose}
              className="text-gray-400 hover:text-gray-600"
            >
              ✕
            </button>
          </div>

          <div className="space-y-4">
            {/* Restaurant Header */}
            <div className="text-center border-b-2 border-dashed border-gray-300 pb-4">
              <h4 className="text-xl font-bold text-gray-800 mb-2">
                {restaurantName}
              </h4>
              <div className="grid grid-cols-2 gap-4 text-sm text-gray-600">
                <div className="text-left">
                  <p>
                    Order No:{" "}
                    {orderDetails.billNumber ||
                      orderDetails.orderId?.slice(-5) ||
                      "N/A"}
                  </p>
                  <p>
                    Date:{" "}
                    {new Date(orderDetails.timestamp).toLocaleDateString(
                      "en-GB"
                    )}
                  </p>
                </div>
                <div className="text-right">
                  <p>
                    Table:{" "}
                    {orderDetails.tableName ||
                      (orderDetails.tableId
                        ? `Table ${orderDetails.tableId}`
                        : "N/A")}
                  </p>
                  <p>
                    Time:{" "}
                    {new Date(orderDetails.timestamp).toLocaleTimeString(
                      "en-US",
                      {
                        hour12: true,
                        hour: "2-digit",
                        minute: "2-digit",
                        second: "2-digit",
                      }
                    )}
                  </p>
                </div>
              </div>
            </div>

            {/* Items Header */}
            <div className="border-b-2 border-dashed border-gray-300 pb-2">
              <div className="grid grid-cols-4 gap-2 text-sm font-semibold text-gray-700">
                <div>Item</div>
                <div className="text-center">Qty</div>
                <div className="text-center">Rate</div>
                <div className="text-right">Amt</div>
              </div>
            </div>

            <div className="space-y-2">
              {orderDetails.items.map((item, index) => (
                <div
                  key={index}
                  className="grid grid-cols-4 gap-2 py-1 border-b border-gray-100"
                >
                  <div className="font-medium text-gray-800 text-sm">
                    {item.name.length > 15
                      ? item.name.substring(0, 15) + "..."
                      : item.name}
                  </div>
                  <div className="text-center text-sm text-gray-600">
                    {item.qty}
                  </div>
                  <div className="text-center text-sm text-gray-600">
                    ₹{item.price}
                  </div>
                  <div className="text-right font-semibold text-gray-800">
                    ₹{(item.qty * item.price).toFixed(2)}
                  </div>
                </div>
              ))}
            </div>

            {/* Total Section */}
            <div className="border-t-2 border-dashed border-gray-300 pt-4">
              {/* Tax Row */}
              <div className="flex justify-between items-center text-base font-medium">
                <span>Tax (5%):</span>
                <span className="text-gray-700">
                  ₹
                  {(
                    orderDetails.items.reduce(
                      (acc, item) => acc + item.qty * item.price,
                      0
                    ) * 0.05
                  ).toFixed(2)}
                </span>
              </div>

              {/* Grand Total */}
              <div className="flex justify-between items-center text-lg font-bold">
                <span>Grand Total:</span>
                <span className="text-rose-600">
                  ₹{orderDetails.total.toFixed(2)}
                </span>
              </div>
            </div>

            {/* Footer */}
            <div className="text-center pt-4 border-t-2 border-dashed border-gray-300">
              <p className="text-sm text-gray-600 font-medium">
                Thank You, Please Visit again
              </p>
              <p className="text-xs text-gray-500 mt-2">Powered by EasiDine</p>
            </div>
          </div>

          <div className="flex gap-3 mt-6 no-print">
            <button
              onClick={onDownload}
              className="flex-1 px-4 py-2 bg-gradient-to-r from-rose-400 to-amber-400 text-white rounded-lg font-medium hover:shadow-md transition-all flex items-center justify-center gap-2"
            >
              <FaReceipt />
              Download Invoice
            </button>
            <button
              onClick={onClose}
              className="px-4 py-2 bg-gray-200 text-gray-700 rounded-lg font-medium hover:bg-gray-300 transition-all"
            >
              Close
            </button>
          </div>
        </div>
      </motion.div>
    </motion.div>
  );
}
